const filtered = '[FILTERED]';

export const honeybadgerSensitiveFields = [
  'authorization',
  'assessment',
  'body',
  'clinical_note',
  'clinicalNote',
  'cookie',
  'creditcard',
  'cvv',
  'data',
  'epn',
  'goals',
  'hpi',
  'medical_history',
  'medicalHistory',
  'mha',
  'objective',
  'password',
  'plan',
  'request_body',
  'ros',
  'session',
  'ssn',
  'subjective',
  'token'
];

const sensitiveKeyPattern =
  /^(authorization|assessment|body|clinical_?note|cookie|creditcard|cvv|data|epn|goals|hpi|medical_?history|mha|objective|password|plan|request_body|ros|session|ssn|subjective|token)$/i;
const sensitiveJsonPattern =
  /"(?:body|clinical_?note|data|medical_?history|subjective|objective|assessment|plan|hpi|ros|epn|mha|goals)"\s*:/i;

export const sanitizeHoneybadgerValue = (value, seen = new WeakSet()) => {
  if (!value || typeof value !== 'object') return value;
  if (seen.has(value)) return filtered;
  seen.add(value);

  if (Array.isArray(value)) {
    return value.map((item) => sanitizeHoneybadgerValue(item, seen));
  }

  return Object.entries(value).reduce((sanitized, [key, nestedValue]) => {
    sanitized[key] = sensitiveKeyPattern.test(key)
      ? filtered
      : sanitizeHoneybadgerValue(nestedValue, seen);
    return sanitized;
  }, {});
};

export const sanitizeHoneybadgerMessage = (message) => {
  if (typeof message !== 'string') return message;

  try {
    return JSON.stringify(sanitizeHoneybadgerValue(JSON.parse(message)));
  } catch (_error) {
    return sensitiveJsonPattern.test(message) ? '[FILTERED SENSITIVE PAYLOAD]' : message;
  }
};

export const sanitizeHoneybadgerNotice = (notice) => {
  if (!notice || typeof notice !== 'object') return notice;

  if (
    /ResizeObserver loop (?:limit exceeded|completed with undelivered notifications)/i.test(
      notice.message
    )
  ) {
    return false;
  }

  notice.message = sanitizeHoneybadgerMessage(notice.message);

  ['context', 'params', 'session', 'details', 'headers', 'cookies', 'cgiData'].forEach((key) => {
    if (notice[key]) notice[key] = sanitizeHoneybadgerValue(notice[key]);
  });

  if (notice.__breadcrumbs) {
    notice.__breadcrumbs = sanitizeHoneybadgerValue(notice.__breadcrumbs);
  }

  return notice;
};

export const toHoneybadgerError = (error, fallbackMessage = 'API request failed') => {
  const message =
    typeof error === 'string' ? error : typeof error?.message === 'string' ? error.message : '';
  const sanitizedError = new Error(sanitizeHoneybadgerMessage(message) || fallbackMessage);

  if (typeof error?.name === 'string') sanitizedError.name = error.name;
  if (typeof error?.stack === 'string') sanitizedError.stack = error.stack;

  return sanitizedError;
};

export const getSafeRequestUrl = (url) =>
  typeof url === 'string' ? url.split('?')[0] : 'unknown-endpoint';
